<template>
    <section class="userSteps">
        <Header />
        <div class="d-flex justify-content-end padSpace" @click="store.clearMessage" v-if="store.error.msg">
            <button type="button" class="close_btn">
                <vue-feather size="26" type="x"></vue-feather>
            </button>
        </div>
        <riskWarning v-if="store.flavorData?.isEu && showRisk"/>
        <riskSuccess v-else-if="store.flavorData?.isEu && testPass"/>
        <testFail v-else-if="store.flavorData?.isEu && testFail" />
        <div class="publicProfile row align-items-center" v-else>
            <div class="col-12 d-flex align-items-center justify-content-between mb-4">
                <router-link class="d-flex align-items-center backBtn medium" :to="{name : 'create_broker_account4',params:{'id':this.$route.params.id}}">
                    <vue-feather class="me-2" type="arrow-left" size="15"></vue-feather> {{$t('decleration.text1')}}
                </router-link>
                <div class="counterStep text-end">
                    <p>{{$t('decleration.text2')}}</p>
                </div>
            </div>
            <div class="col-12">
                <div class="mainTitle mb-5">
                    <h3 class="mb-3 clash">{{$t('decleration.text3')}}<span class="bgTitle">{{$t('decleration.text4')}}</span></h3>
                </div>
            </div>
            <div class="col-12">
                <h4 class="mb-4">{{$t('decleration.text5')}}</h4>
                <Form class="row personalDetails" @submit="submit">
                    <div class="col-12">
                        <ul class="d-flex align-items-center flex-wrap mb-3">
                            <li>
                                <label class="customCheckBox mb-4">
                                    <span class="name">{{$t('decleration.text6')}}</span>
                                    <input
                                      type="checkbox"
                                      class="form-control"
                                      v-model="form.risk"
                                    />
                                    <Field type="hidden" name="declaration1" rules="required" v-if="!form.risk"/>
                                    <span class="checkmark"></span>
                                </label>
                                <ErrorMessage name="declaration1" class="text-danger" />
                            </li>
                            <li>
                                <label class="customCheckBox mb-4">
                                    <span class="name">{{$t('decleration.text7')}}<a href="https://fxview.com/static/fxview/pdf/legal-document/Client_ Agreement.pdf" target="_blank" class="underline">{{$t('decleration.text8')}}</a>, <a href="https://fxview.com/static/fxview/pdf/legal-document/Client-Identification-Procedure.pdf"  target="_blank" class="underline">{{$t('decleration.text9')}}</a>, <a href="https://fxview.com/static/fxview/pdf/legal-document/Best-Interest-and-Order-Execution-Policy-MN-Mar-2020.pdf" class="underline" target="_blank">{{$t('decleration.text10')}}</a>, <a href="https://fxview.com/static/fxview/pdf/legal-document/Conflicts_of_Interest_Policy_Summary.pdf" class="underline" target="_blank">{{$t('decleration.text11')}}</a>, <a href="https://fxview.com/static/fxview/pdf/legal-document/Client-Categorisation-Procedure.pdf" class="underline" target="_blank">{{$t('decleration.text12')}}</a>, <a href="https://fxview.com/static/fxview/pdf/legal-document/Investor_Compensation_Fund.pdf" class="underline" target="_blank">{{$t('decleration.text13')}}</a>, <a href="https://fxview.com/static/fxview/pdf/legal-document/Key_Information_Document_FX_CFD_100920.pdf" class="underline" target="_blank">{{$t('decleration.text14')}}</a>, <a :href="`https://fxview.com/privacy-policy`" class="underline" target="_blank">{{$t('decleration.text15')}}</a>{{$t('decleration.text16')}}<a :href="`${static_vars.domainURL}risk-disclaimer`" target="_blank" class="underline">{{$t('decleration.text17')}}</a>.</span>
                                    <input
                                      type="checkbox"
                                      class="form-control"
                                      v-model="form.readAll"
                                    />
                                   <Field type="hidden" name="declaration2" rules="required" v-if="!form.readAll"/>
                                    <span class="checkmark"></span>
                                </label>
                                <ErrorMessage name="declaration2" class="text-danger" />
                            </li>
                            <li>
                                <label class="customCheckBox mb-4">
                                    <span class="name">{{$t('decleration.text18')}}<a :href="`https://fxview.com/privacy-policy`" target="_blank" class="underline">{{$t('decleration.text19')}}</a> {{$t('decleration.text20')}}</span>
                                    <input
                                      type="checkbox"
                                      class="form-control"
                                      v-model="form.personaldata"
                                    />
                                   <Field type="hidden" name="declaration3" rules="required" v-if="!form.personaldata"/>
                                    <span class="checkmark"></span>
                                </label>
                                <ErrorMessage name="declaration3" class="text-danger" />
                            </li>
                            <li>
                                <label class="customCheckBox mb-4">
                                    <span class="name">{{$t('decleration.text21')}}</span>
                                    <input
                                      type="checkbox"
                                      class="form-control"
                                      v-model="form.charltage"
                                    />
                                   <Field type="hidden" name="declaration4" rules="required" v-if="!form.charltage"/>
                                    <span class="checkmark"></span>
                                </label>
                                <ErrorMessage name="declaration4" class="text-danger" />
                            </li>
                        </ul>
                        <p class="customAlert position-relative f-13"><i class="alertCircle fa fa-exclamation" aria-hidden="true"></i>{{$t('decleration.text22')}}</p>
                    </div>
                    <div class="col-6 mt-4">
                        <button type="submit" class="grd_btn full_size">{{$t('decleration.text23')}}</button>
                    </div>
                </Form>
            </div>
        </div>
    </section>
     <!-- Data Featching Loader Here -->

    
     <div class="modal fade giftModal featchData show" v-if="store.singleLoading">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="position-relative d-flex align-items-center justify-content-between overflow-hidden">
                        <div class="featchLogo">
                            <img :src="`${static_vars.imagePath}/assets/images/loaderIcon/fxSmal.png`" alt="ZuluTrade" title="ZuluTrade">
                        </div>
                        <div class="position-absolute loader-line">
                            <img :src="`${static_vars.imagePath}/assets/images/loaderIcon/ltRts.png`" alt="ZuluTrade" title="ZuluTrade">
                        </div>
                        <div class="featchLogo">
                            <img :src="`${static_vars.imagePath}/assets/images/loaderIcon/zulSmal.png`" alt="Fxview" title="Fxview">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useMainStore } from "@/store";
import { Form, Field, ErrorMessage } from "vee-validate";
import riskWarning from "@/components/shared/riskWarning.vue"
import riskSuccess from "@/components/shared/riskSuccess.vue"
import testFail from "@/components/shared/testFail.vue"
export default {
    setup() {
        const store = useMainStore();
        return { store };
    },
    data() {
        return {
            form : {
                risk : false,
                readAll : false,
                personaldata : false,
                charltage : false,
            },
            showRisk : false,
            testFail : false,
            testPass : false
        }
    },
    components : {
        Form,
        Field,
        ErrorMessage,
        riskWarning,
        riskSuccess,
        testFail
    },
    methods:{
        submit(){
            this.store.saveBrokerTerms({},true,this.$route.params.id,this)
        },
        getCurrentStatus(){
            this.store.callUserBrokerStatusList({},true,this.$route.params.id).then((response) => {
                if(Object.keys(response).length && response?.currentStep == 4 && response?.stepsStatus?.length){
                    let data = response?.stepsStatus.filter(i => i?.step == 'Questionnaire');
                    if(data.length && data?.[0]?.questionnaireDetails){
                        if(parseInt(data?.[0]?.questionnaireDetails?.data?.total_points) >= 15){//Test Passed , Enable Declaration
                            this.testPass = true
                            this.testFail = false
                            this.showRisk = false
                        }else if(parseInt(data?.[0]?.questionnaireDetails?.data?.total_points) < 2 ){//Test failed
                            this.testFail = true
                            this.testPass = false
                            this.showRisk = false
                        }else{
                            if(parseInt(data?.[0]?.questionnaireDetails?.data?.total_points) >=2 && parseInt(data?.[0]?.questionnaireDetails?.data?.total_points) < 15){//Risk Warning Accept or Reject
                                this.testPass = false
                                switch (parseInt(data?.[0]?.questionnaireDetails?.data?.risk_warning)){
                                    case 0:
                                        // poup warning not accepted neither rejected
                                        this.showRisk = true;
                                        break;
                                    case 1:
                                        // poup warning accepted, so don't show warning
                                        this.showRisk = false;
                                        this.testFail = false;
                                        break;
                                    case 2:
                                        // poup warning rejected, so show test failed message
                                        this.testFail = true;
                                        break;
                                    default:
                                        break;
                                }
                            }
                        }
                    }
                }
            })
        }
    },
    created(){
        if(this.store.flavorData?.isEu){
            this.getCurrentStatus()
        }
    }
}
</script>